import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Platforms from '../components/Platforms';
import Solutions from '../components/Solutions';
import Services from '../components/Services';
import Approach from '../components/Approach';
import Team from '../components/Team';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Home: React.FC = () => {
  const { hash } = useLocation();

  // Nach Navigation von einer Unterseite mit Anker (z. B. /#kontakt) zum Abschnitt springen
  useEffect(() => {
    if (!hash) return;
    const id = hash.slice(1);
    const t = window.setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 80);
    return () => window.clearTimeout(t);
  }, [hash]);

  return (
    <div className="min-h-screen overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <Platforms />
        <Solutions />
        <Services />
        <Approach />
        <Team />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
